import { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { EAssistantPhase } from '../../../../store/reducers/admin/assistant';
import { updatePhase } from '../../../../store/actions/admin/assistant';
import Icon, { COLORS, ICONS } from '../../../general-ui/icon';
import './welcome.scss';
import { completeWelcomeOnboarding } from '../../../../store/actions/authentication';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import welcomeImage1 from '../../../../images/assistant-welcome-1.png';
import welcomeImage2 from '../../../../images/welcome-2.png';
import welcomeImage3 from '../../../../images/welcome-3.png';
import welcomeImage4 from '../../../../images/welcome-4.png';
import welcomeImage5 from '../../../../images/new-assistant-welcome-5-1.png';

const WelcomeAssistant: React.FC = () => {
	const {
		AuthReducer: {
			user,
			token
		}
	} = useTypedSelector(state => state);

	const dispatch = useDispatch();

	const [currentPage, setCurrentPage] = useState(0);

	// Update user account if needed when completing the welcome panel
	async function handleComplete() {
		if (user) {
			// if the user has already completed the welcome panel, bring them to the menu
			if (user?.onboarded.includes("welcome"))
				dispatch(updatePhase(EAssistantPhase.MENU));
			else {
				// The user has not completed the welcome panel before
				// Update their account and proceed to  the progress checklist panel
				await dispatch(completeWelcomeOnboarding(token!, user.id, user.onboarded));
				dispatch(updatePhase(EAssistantPhase.PROGRESS));
			}
		}
	}

	// render the button at the bottom of the welcome panel based on what the current page is
	const renderButton = useMemo(() => {
		switch (currentPage) {
			case 0: {
				return (
					<button
						className="primary"
						onClick={() => setCurrentPage(currentPage + 1)}
					>
						Let's begin
					</button>
				);
			}
			case 1: {
				return (
					<button
						className="primary"
						onClick={() => setCurrentPage(currentPage + 1)}
					>
						Next
					</button>
				);
			}
			case 2: {
				return (
					<button
						className="primary"
						onClick={() => setCurrentPage(currentPage + 1)}
					>
						Next
					</button>
				);
			}
			case 3: {
				return (
					<button
						className="primary"
						onClick={() => setCurrentPage(currentPage + 1)}
					>
						Next
					</button>
				);
			}
			case 4: {
				return (
					<button
						className="primary"
						onClick={() => handleComplete()}
					>
						Okay
					</button>
				);
			}
			default: return;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage]);

	// redner the description text below the image based on the surrent page number
	const description = useMemo(() => {
		switch (currentPage) {
			case 0: {
				return (
					<p>
						You are about to create your first event! Pretty exciting, right?
						But first, let's take a look around.
					</p>
				);
			}
			case 1: {
				return (
					<p>
						This is a landing page where visitors can learn more about your event and find an event agenda.
						With a few simple tweaks, you can make it useful and attractive.
					</p>
				);
			}
			case 2: {
				return (
					<p>
						Visitors will need to complete a registration form before coming to a page. A registration page is recommended if you're
						gating your event or looking to capture more information about attendees.
					</p>
				);
			}
			case 3: {
				return (
					<p>
						Keeping attendees engaged at your event has never been so easy. Let's build out the attendee experience during your event.
					</p>
				);
			}
			case 4: {
				return (
					<p>
						A good way to better understand basic functions is to complete a series of tasks.
						It will take no more than 15 minutes and walk you through how to easily create a beautifully designed event.
					</p>
				);
			}
			default: return "";
		}
	}, [currentPage]);

	const panelImage = useMemo(() => {
		switch (currentPage) {
			case 0: {
				return (
					<img src={welcomeImage1} alt="welcome"></img>
				);
			}
			case 1: {
				return (
					<img src={welcomeImage2} alt="welcome"></img>
				);
			}
			case 2: {
				return (
					<img src={welcomeImage3} alt="welcome"></img>
				);
			}
			case 3: {
				return (
					<img src={welcomeImage4} alt="welcome"></img>
				);
			}
			case 4: {
				return (
					<img src={welcomeImage5} alt="welcome"></img>
				);
			}
			default: return <></>;
		}
	}, [currentPage]);

	return (
		<div className="welcome-assistant-container">
			<div className="welcome-header">
				<button className="no-style" onClick={() => dispatch(updatePhase(EAssistantPhase.MENU))}><Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.WHITE} /></button>
				<h4>Welcome</h4>
			</div>
			<div className="welcome-body">
				<div className="image" >{panelImage}</div>
				<div className="description">
					{description}
				</div>
			</div>
			<div className="welcome-footer">
				{currentPage > 0 ? <button className="round prev" onClick={() => setCurrentPage(currentPage - 1)}><Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.DEFAULT_GRAY} /></button> : <></>}
				<span>{currentPage > 0 ? `${currentPage + 1} / 5` : ""}</span>
				{renderButton}
			</div>
		</div>
	);
};

export default WelcomeAssistant;